import { Text } from '@clockout-dev/design-elements';
import styles from '../styles/configurationCard.module.scss';

function ConfigurationCardHeader({ title, icon, action, classNames }) {
    return (
        <div className={classNames ? `${styles.cardHeader} ${classNames}` : styles.cardHeader}>
            <div className={styles.cardHeaderLeft}>
                {icon ? <span className={styles.cardHeaderIcon} aria-hidden="true">{icon}</span> : null}
                <Text as="span" size="s" className={styles.cardHeaderTitle}>
                    {title}
                </Text>
            </div>
            {action}
        </div>
    );
}
export default ConfigurationCardHeader;
